import React from "react";

import { NotSubscribedRoute } from "@src/domains/NotSubscribed";
import { GoogleCallbackRoute } from "@src/features/integrations/Google/GoogleCallback";

import { GENERAL_ROUTES } from "../../routes";

export const GeneralFullPageRoutes = [
  {
    path: GENERAL_ROUTES.GoogleIntegrationCallback,
    element: <GoogleCallbackRoute />,
  },
  {
    path: GENERAL_ROUTES.NotSubscribed,
    element: <NotSubscribedRoute />,
  },
  {
    // Lazy so the QA results chain (AG Grid, finding modal) stays out of the
    // main bundle and only loads when the review page is opened.
    path: GENERAL_ROUTES.QaReview,
    lazy: async () => {
      const { QaReviewRoute } =
        await import("@src/features/ai/pages/qa/qa-review/QaReview.route");
      return { element: <QaReviewRoute /> };
    },
  },
];
